// Static option lists used by select fields in the WLC RTC screener.
// Kept in one file so they can be imported by both the question definitions
// and validation tests without circular dependencies.

export const GENDER_OPTIONS = [
    'Female',
    'Male',
    'Non-binary',
    'Prefer not to say',
    'Prefer to self-describe',
];

export const ETHNICITY_OPTIONS = [
    'Asian/Asian British - Bangladeshi',
    'Asian/Asian British - Chinese',
    'Asian/Asian British - Indian',
    'Asian/Asian British - Pakistani',
    'Asian/Asian British - Other',
    'Black/Black British - African',
    'Black/Black British - Caribbean',
    'Black/Black British - Other',
    'Mixed Race/Mixed Race British - White and Asian',
    'Mixed Race/Mixed Race British - White and Black African',
    'Mixed Race/Mixed Race British - White and Black Caribbean',
    'Mixed Race/Mixed Race British - Other Mixed Race Background',
    'White - British',
    'White - Gypsy or Irish Traveller',
    'White - Irish',
    'White - Other',
    'Other ethnic group - Arab',
    'Other ethnic group - Other',
    'Prefer not to say',
    'Prefer to self-describe',
];

// ASRS Part A frequency labels (identical across all provider screeners)
export const ASRS_RATING_OPTIONS = [
    'Never',
    'Rarely',
    'Sometimes',
    'Often',
    'Very Often',
];

// Functional-impairment Likert labels (1-5 scale)
export const IMPAIRMENT_LIKERT_OPTIONS = [
    { value: '1', label: 'Not at all' },
    { value: '2', label: 'A little' },
    { value: '3', label: 'Somewhat' },
    { value: '4', label: 'Quite a lot' },
    { value: '5', label: 'A great deal' },
];

// Yes / No radio options for previous-assessment questions
export const YES_NO_OPTIONS = ['Yes', 'No'];

// Phone country codes (UK-centric, small set)
export const PHONE_COUNTRIES = [
    { code: 'GB', dialCode: '+44', trunkPrefix: '0' },
    { code: 'IE', dialCode: '+353', trunkPrefix: '0' },
    { code: 'US', dialCode: '+1', trunkPrefix: '' },
    { code: 'FR', dialCode: '+33', trunkPrefix: '0' },
];

export const DEFAULT_PHONE_COUNTRY = 'GB';
